import React, { useState } from 'react';

const ChatInput = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center">
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={disabled}
        className="flex-1 p-3 border border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[rgb(40,93,84)] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
        placeholder={disabled ? "Sending..." : "Type your message..."}
        aria-label="Type your message"
        autoComplete="off"
        autoCapitalize="sentences"
        enterKeyHint="send"
      />
      <button
        type="submit"
        disabled={disabled || !message.trim()}
        className="bg-[rgb(40,93,84)] hover:bg-[rgb(30,70,63)] text-white font-bold p-3 rounded-r-lg transition-colors touch-manipulation tap-target disabled:bg-gray-400 disabled:cursor-not-allowed"
        aria-label="Send message"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6"
        >
          <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
        </svg>
      </button>
    </form>
  );
};

export default ChatInput;
